/**
 * Register status as the design's tones.
 *
 * `statusVariant` in `lib/ariregister.ts` returns a shadcn `Badge` variant,
 * which is the pre-redesign vocabulary. The list draws the CRM's `StatusPill`,
 * so it needs the same statuses said in the CRM's five tones. The helper stays
 * where it is - the entity detail page still uses it.
 */
import type { StatusTone } from "../../ui";

/**
 * R = registered and trading, L = liquidation, K/N = struck off or never
 * started. Anything else the register sends is neutral rather than guessed at.
 */
export function registerTone(status: string | null): StatusTone {
  if (status === "R") return "ok";
  if (status === "L") return "wt";
  if (status === "K" || status === "N") return "lt";
  return "mut";
}
